export default __webpack_public_path__ + "static/media/prize-3.b6b39148.webp";